<template v-if="chartData">
  <div :id="`${chartData.name}ChartWrapper`" class="chart__wrapper">
    <h6 class="chart__title">{{ chartData.title }}</h6>
    <span class="chart__subtitle">{{ chartData.subtitle }}</span>
    <div class="chart__canvas_wrapper">
      <canvas :id="chartData.name"></canvas>
    </div>
  </div>
</template>

<script>
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Tooltip,
  Legend,
  BarController,
  BarElement,
} from 'chart.js'

Chart.register(
  Tooltip,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Legend,
  BarController,
  BarElement,
)

var isDollarSignNeeded = false

export default {
  name: 'BarChart',
  props: {
    barChartData: {
      type: Object,
      default: () => {}
    },
    selectedQuestion: {
      type: String,
      default: "I feel that I am regularly able to afford basic living expenses with my current income."
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          name: "GoalProgression",
          title: "Goal Progression",
          subtitle: "I feel that I am regularly able to afford basic living expenses with my current income.",
          data: {
            labels: ["Month 2", "Month 6", "Month 8", "Month 12"],
            datasets: [{
              data: [65, 59, 80, 81, 56, 55, 40],
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(201, 203, 207, 0.2)'
              ],
              borderColor: [
                'rgb(255, 99, 132)',
                'rgb(255, 159, 64)',
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(54, 162, 235)',
                'rgb(153, 102, 255)',
                'rgb(201, 203, 207)'
              ],
              borderWidth: 1
            }]
          }
        }
      }
    },
    charts: {
      type: Array,
      default: () => [],
    },
    isDollarSignNeeded: {
      type: Boolean,
    },
  },
  data() {
    return {
      chart: null,
      config: {
        type: 'bar',
        data: {},
        options: {
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          }
        }
      }
    }
  },
  updated() {
    if(this.chart)
      this.chart.destroy()

    this.createBarChart()
  },
  mounted() {
    this.createBarChart()
  },
  methods: {
    reduceQuestionByMonth(questions) {
      return questions.reduce((totals, question) => {
        if (question.month === 2) {
            totals[0] = (totals[0] || 0) + parseInt(question.count)
        }
        if (question.month === 6) {
            totals[1] = (totals[1] || 0) + parseInt(question.count)
        }
        if (question.month === 8) {
            totals[2] = (totals[2] || 0) + parseInt(question.count)
        }
        if (question.month === 12) {
            totals[3] = (totals[3] || 0) + parseInt(question.count)
        }

        return totals
      }, [0, 0, 0, 0])
    },
    createBarChart() {
      const defaultBarChartData = {
        labels: ["Month 2", "Month 6", "Month 8", "Month 12"],
        datasets: [{
          data: [0,0,0,0,0,0],
          backgroundColor: [ '#1D5A5F'],
          borderColor: [ '#1D5A5F'],
          borderWidth: 1
        },
        {
          data: [0,0,0,0,0,0],
          backgroundColor: [ '#FEDA67'],
          borderColor: [ '#FEDA67'],
          borderWidth: 1
        },
        {
          data: [0,0,0,0,0,0],
          backgroundColor: ['#47B393' ],
          borderColor: ['#47B393' ],
          borderWidth: 1
        }]
      }

      this.chartData.subtitle = this.selectedQuestion

      const answers = ['Disagree strongly', 'Disagree somewhat', 'Neither agree nor disagree', 'Agree somewhat', 'Agree strongly']
      const months = [2, 6, 8, 12]

      const dataByQuestion = this.barChartData.filter(datum => {
          return datum.question === this.selectedQuestion
      })

      const agreedQuestions = dataByQuestion.filter(datum => {
          return datum.answer === 'Agree somewhat' || datum.answer === 'Agree strongly'
      })

      const neutralQuestions = dataByQuestion.filter(datum => {
          return datum.answer === 'Neither agree nor disagree'
      })

      const disagreeQuestions = dataByQuestion.filter(datum => {
          return datum.answer === 'Disagree somewhat' || datum.answer === 'Disagree strongly'
      })

      const agreedDataByMonth = this.reduceQuestionByMonth(agreedQuestions)
      const neutralDataByMonth = this.reduceQuestionByMonth(neutralQuestions)
      const disagreeDataByMonth = this.reduceQuestionByMonth(disagreeQuestions)

      defaultBarChartData.datasets[0].data = agreedDataByMonth
      defaultBarChartData.datasets[0].label = "Agreed (Strongly or Somewhat)"

      defaultBarChartData.datasets[1].data = neutralDataByMonth
      defaultBarChartData.datasets[1].label = "Neutral"

      defaultBarChartData.datasets[2].data = disagreeDataByMonth
      defaultBarChartData.datasets[2].label = "Disagree (Strongly or Somewhat)"

      const ctx = document.getElementById(this.chartData.name)

      this.config.data = defaultBarChartData

      /*Chart.defaults.global.defaultFontFamily = 'Poppins-Light'*/
      /*Chart.defaults.global.defaultFontColor = '#000'*/
      /*Chart.defaults.global.defaultFontStyle = 'bold'*/

      var chart = new Chart(ctx, this.config)
      this.chart = chart

      /*chart.canvas.parentNode.style.height = '600px';*/

      const chartWrapper = document.getElementById(`${this.chartData.name}ChartWrapper`)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.chart {
  &__wrapper {
    border: 1px solid $soft-gray;
    display: inline-block;
    width: 100%;
    padding: 1em;
  }

  &__subtitle {
    font-style: italic;
  }

  &__title {
    margin-bottom: 0;
    color: $black;
  }

  &__canvas_wrapper {
    position: relative;
  }
}
</style>
